<template>
<div class="chapter">
<div class="inner_page">
<h1>The Art of Wood Fired Cooking</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">How I Became a Pizzaiolo</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch02">Introduction</a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Pizza, Calzones, and Flatbread</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">Seafood</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">Poultry</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">Meat</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">Vegetables</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">Pasta, Rice, and Eggs</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch09" title="Link target outside of Sample">Bread</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch10" title="Link target outside of Sample">Desserts</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch11" title="Link target outside of Sample">Metric Conversion Chart</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?032c6ecf